import React from 'react';
import { Link } from 'react-router-dom-latest';

const HeaderTabs = ({ data, customClasses, handleClick, activeTab, pageName }) => (
  <ul
    className={customClasses ? `nav nav-tabs ${customClasses}` : 'nav nav-tabs'}
  >
    {data.map((each, key) => (
      <li className="nav-item" key={each.value}>
        {each.url ? (
          <Link
            className={activeTab === key ? 'nav-link active' : 'nav-link'}
            to={each.url}
            onClick={() => handleClick(key, each)}
            data-testid={`${pageName}__${each?.label?.toLowerCase()?.split(' | ')[0]}`}
          >
            {each.label}
          </Link>
        ) : (
          <button
            type="button"
            className={activeTab === key ? 'nav-link active' : 'nav-link'}
            data-toggle="tab"
            onClick={() => handleClick(key, each)}
            data-testid={`${pageName}__${each?.label?.toLowerCase()?.split(' | ')[0]}`}
          >
            {each.label}
          </button>
        )}
      </li>
    ))}
  </ul>
);

export default HeaderTabs;
